import { Article } from 'services/news';

import { HomeContentItem } from '../types/home-page.type';

const formatVideoDuration = (duration?: string): string | undefined => {
	if (!duration) {
		return undefined;
	}

	const asNumber = Number(duration);
	if (Number.isNaN(asNumber)) {
		return duration;
	}

	// Duration from API is often milliseconds
	const totalSeconds =
		asNumber > 1000 ? Math.round(asNumber / 1000) : asNumber;
	const minutes = Math.floor(totalSeconds / 60);
	const seconds = totalSeconds % 60;
	return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

export const mapContentItemToArticle = (item: HomeContentItem): Article => {
	const categoryName = item.categoryName ?? '';
	const isVideo =
		categoryName.toLowerCase() === 'video' ||
		Boolean(item._embedded?.video);
	const isGallery = categoryName.toLowerCase().includes('gallery');
	const image = item._embedded?.image;
	const authors = item._embedded?.authors ?? [];
	const firstAuthor = authors[0];

	return {
		title: item.title,
		schemaDate: item.publishedDate ?? '',
		summary: item.summary ?? '',
		categoryName,
		isVideo,
		isGallery,
		url: item._links?.['content:webpage']?.href ?? '',
		image: {
			url: image?.url ?? '',
			alt: image?.altText ?? item.title,
		},
		tags: (item._links?.['content:tags'] ?? []).map((tag) => ({
			href: tag.href,
			title: tag.title,
		})),
		author: firstAuthor?.name ?? null,
		primaryTag: item.primaryTag ?? '',
		isPremium: Boolean(item.isPremium),
		videoDuration: formatVideoDuration(item._embedded?.video?.duration),
		isSignInRequired: Boolean(item.isSignInRequired),
	};
};
